import apiService from './ApiService';

class CursoService {
  async getCursos(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/cursos${qs ? `?${qs}` : ''}`);
    const cursos = response?.cursos || response?.Cursos || response?.data || response || [];
    const items = Array.isArray(cursos) ? cursos : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getCursosActivos(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/cursos/activos${qs ? `?${qs}` : ''}`);
    const cursos = response?.cursos || response?.Cursos || response?.data || response || [];
    const items = Array.isArray(cursos) ? cursos : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getMisCursos(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.search) params.append('search', options.search);
    if (options.cicloLectivo !== undefined && options.cicloLectivo !== null && options.cicloLectivo !== '') params.append('cicloLectivo', options.cicloLectivo);
    if (options.anio !== undefined && options.anio !== null && options.anio !== '') params.append('anio', options.anio);
    if (options.division) params.append('division', options.division);
    const qs = params.toString();
    const response = await apiService.get(`/cursos/mis${qs ? `?${qs}` : ''}`);
    const cursos = response?.cursos || response?.Cursos || response?.data || response || [];
    const items = Array.isArray(cursos) ? cursos : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getMisCursosProfesor(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.search) params.append('search', options.search);
    if (options.cicloLectivo !== undefined && options.cicloLectivo !== null && options.cicloLectivo !== '') params.append('cicloLectivo', options.cicloLectivo);
    if (options.anio !== undefined && options.anio !== null && options.anio !== '') params.append('anio', options.anio);
    if (options.division) params.append('division', options.division);
    const qs = params.toString();
    const response = await apiService.get(`/cursos/mis/profesor${qs ? `?${qs}` : ''}`);
    const cursos = response?.cursos || response?.Cursos || response?.data || response || [];
    const items = Array.isArray(cursos) ? cursos : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getAlumnoPanel(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    const qs = params.toString();
    return apiService.get(`/cursos/mis/alumno-panel${qs ? `?${qs}` : ''}`);
  }

  async getCursoById(id) {
    const response = await apiService.get(`/cursos/${id}`);
    const list = response?.cursos || response?.Cursos || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response;
  }

  async createCurso(payload) {
    const response = await apiService.post('/cursos', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el curso.';
      throw new Error(msg);
    }
    return response;
  }

  async updateCurso(id, payload) {
    const response = await apiService.put(`/cursos/${id}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el curso.';
      throw new Error(msg);
    }
    return response;
  }

  async deleteCurso(id) {
    if (!id) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const response = await apiService.delete(`/cursos/${id}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos eliminar el curso.';
      throw new Error(msg);
    }
    return response;
  }

  async getProfesoresPorCurso(cursoId) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const response = await apiService.get(`/cursos/${cursoId}/profesores`);
    const profesores = response?.profesores || response?.Profesores || response?.data || response || [];
    return Array.isArray(profesores) ? profesores : [];
  }

  async getAlumnosPorCurso(cursoId) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const response = await apiService.get(`/cursos/${cursoId}/alumnos`);
    const alumnos = response?.alumnos || response?.Alumnos || response?.data || response || [];
    return Array.isArray(alumnos) ? alumnos : [];
  }

  async getCursoEstructuraAcademica(cursoId) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const response = await apiService.get(`/cursos/${cursoId}/estructura-academica`);
    const materias = response?.materias || response?.Materias || response?.data || response || [];
    return Array.isArray(materias) ? materias : [];
  }

  async syncCursoEstructuraAcademica(cursoId, payload = {}) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const response = await apiService.put(`/cursos/${cursoId}/estructura-academica`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos guardar la estructura académica del curso.';
      throw new Error(msg);
    }
    return response;
  }

  async assignProfesores(cursoId, profesorIds) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const ids = Array.isArray(profesorIds) ? profesorIds : [];
    const response = await apiService.post(`/cursos/${cursoId}/profesores/asociar`, {
      profesorIds: ids
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos asociar los profesores.';
      throw new Error(msg);
    }
    return response;
  }

  async removeProfesores(cursoId, profesorIds) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const ids = Array.isArray(profesorIds) ? profesorIds : [];
    const response = await apiService.post(`/cursos/${cursoId}/profesores/desasociar`, {
      profesorIds: ids
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos desasociar los profesores.';
      throw new Error(msg);
    }
    return response;
  }

  async removeAlumnos(cursoId, alumnoIds) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const ids = Array.isArray(alumnoIds) ? alumnoIds : [];
    const response = await apiService.post(`/cursos/${cursoId}/alumnos/desasociar`, {
      alumnoIds: ids
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos desvincular los alumnos.';
      throw new Error(msg);
    }
    return response;
  }

  async removeMaterias(cursoId, materiaIds) {
    if (!cursoId) {
      throw new Error('No se encontró el curso seleccionado.');
    }
    const ids = Array.isArray(materiaIds) ? materiaIds : [];
    const response = await apiService.post(`/cursos/${cursoId}/materias/desasociar`, {
      materiaIds: ids
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos desvincular las materias del curso.';
      throw new Error(msg);
    }
    return response;
  }
}

const cursoService = new CursoService();
export default cursoService;
